/**
 * Dana icon URL
 * Indonesia's popular e-wallet payment method
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const DANA_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/79Uj5xItEZE7L51j2oh6IV/6af4cfefdd65834305931fd16f652d87/DANA.svg';
